import React, { useContext, useEffect, useState } from "react";
import SellerSidebar from "./common/SellerSidebar";
import { Link, useNavigate, useParams } from "react-router-dom";
import CommanPagination from "../pages/common/CommanPagination/CommanPagination";
import { organizationDetail } from "../Context/SelectedOrganization";
import axiosClient from "../Services/Axios/axios";
import { BeatLoader } from "react-spinners";
import DateFormatter from "../pages/common/DateFormatter/DateFormatter";

function Employees() {
  const { organizationData } = useContext(organizationDetail);
  const [loader, setLoader] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(8);
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);

  const getEmployeeList = async () => {
    // Your API call logic here
    try {
      setLoader(true);
      const response = await axiosClient.post(
        `employees/${process.env.REACT_APP_API_VERSION}/list`,
        {
          organization_id: sessionStorage.getItem("organization_id"),
        }
      );
      if (!response.data.error) {
        setLoader(false);
        setRoles(response.data.data);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
    getEmployeeList();
  }, [searchQuery, limit, organizationData]);

  return (
    <>
      <div className="all_suport_bg manages_top">
        <section className="ser_v_araeea profiles">
          <div className="container">
            <div className="bradcams">
              <span className="bothss">
                <Link to="">Dashboard</Link>{" "}
                <img src="/images/brd_rowwo.png" alt="" /> Employees
              </span>
            </div>
            <div className="row">
              <div className="col-lg-3 mb_view_hide">
                <SellerSidebar />
              </div>

              <div className="col-lg-9 order-list">
                <div
                  className="d-flex justify-content-between align-items-center mb-3"
                  style={{ gap: "12px" }}
                >
                  <h4 style={{ fontWeight: "600" }}>Employees List</h4>
                  {/* Left: Search + Filter */}
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: "8px" }}
                  >
                    <div
                      className=""
                      style={{ position: "relative", width: "250px" }}
                    >
                      <Link to={"/employees/send-invitaion"}>
                        <button className="btn-access">Send Invitation</button>
                      </Link>
                    </div>
                    {/* <button className="btn-filter">
                      <img src="/images/controls-alt.png" alt="filter" />
                    </button> */}
                  </div>
                </div>

                {/* Order List */}
                <div className="form_boxx profilss">
                  <div className="form_arar mt-0">
                    <div className="d-flex justify-content-between mb-3">
                      {/* <h5>Employees ({totalCounts})</h5> */}
                      {/* <a href="">View All</a> */}
                    </div>
                    {/* Scroll wrapper */}
                    <div style={{ overflowX: "auto" }}>
                      <table className="orders-table">
                        <thead>
                          <tr className="table-header">
                            <th className="header-cell">S. No.</th>
                            <th className="header-cell">Employee ID</th>
                            <th className="header-cell">Name</th>
                            <th className="header-cell">Contact No.</th>
                            <th className="header-cell">Email</th>
                            <th className="header-cell">Role type</th>
                            <th className="header-cell">Joining Date</th>
                            <th className="header-cell">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* Loader Centered */}
                          {loader && (
                            <tr>
                              <td colSpan="8">
                                <div className="loader-center">
                                  <BeatLoader color="#097C81" />
                                </div>
                              </td>
                            </tr>
                          )}

                          {/* No Data Found */}
                          {!loader &&
                            (!roles?.rows || roles.rows.length === 0) && (
                              <tr>
                                <td colSpan="8">
                                  <div className="no-data-center">
                                    No Data Found
                                  </div>
                                </td>
                              </tr>
                            )}

                          {/* Table Rows */}
                          {!loader &&
                            roles?.rows?.map((role, index) => (
                              <tr key={role?.id} className="table-row">
                                <td className="table-cell serial-number">
                                  {(currentPage - 1) * limit + index + 1}.
                                </td>

                                <td className="table-cell">
                                  {role?.employee_id}
                                </td>
                                <td className="table-cell">{role?.name}</td>
                                <td className="table-cell">{role?.phone}</td>
                                <td className="table-cell">{role?.email}</td>
                                <td className="table-cell">
                                  {role?.role?.role_name
                                    ? role?.role?.role_name
                                    : "N/A"}
                                </td>
                                <td className="table-cell">
                                  {DateFormatter(role.created_at)}
                                </td>

                                <td
                                  className={`table-cell status ${
                                    role.status === 0
                                      ? "status-pending"
                                      : "status-confirmed"
                                  }`}
                                >
                                  {role.status === 0 ? "Pending" : "Confirmed"}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                {/* Pagination */}
                <div className="pages_liststs">
                  <CommanPagination
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    limit={limit}
                    totalCounts={roles.totalElement}
                    totalPage={roles.totalPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Employees;
